import React, { useEffect, useState } from 'react';
export const HeroSection = () => {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    // Trigger the animation after component mounts
    setIsVisible(true);
  }, []);
  return <section className="relative w-full h-[80vh] bg-cover bg-center" style={{
    backgroundImage: "url('https://uploadthingy.s3.us-west-1.amazonaws.com/uNVT4h1eQ3WMRTj8LxPUqu/rock-formation-against-sea-sunny-day.jpg')"
  }} data-id="element-160">
      <div className="absolute inset-0 bg-black bg-opacity-40" data-id="element-161"></div>
      <div className="container mx-auto px-4 h-full flex items-center relative z-10" data-id="element-162">
        <div className="max-w-3xl text-white" data-id="element-163">
          <h1 className={`text-5xl md:text-6xl font-bold mb-4 transform transition-all duration-1000 ease-out ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'}`} data-id="element-164">
            Relaxed walking holidays in small groups
          </h1>
          <p className={`text-xl md:text-2xl mb-8 transform transition-all duration-1000 ease-out delay-300 ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'}`} data-id="element-165">
            Personal approach and a local guide who takes care of everything.
            Experience, enjoy and discover the beautiful nature and the local
            colour.
          </p>
          <div className={`flex flex-col sm:flex-row gap-4 transform transition-all duration-1000 ease-out delay-500 ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'}`} data-id="element-166">
            <a href="/join" className="bg-teal-600 hover:bg-teal-700 text-white font-medium py-3 px-6 rounded-md text-center transition duration-300" data-id="element-167">
              Join a Trip
            </a>
            <a href="#reviews" className="bg-white hover:bg-gray-100 text-teal-600 font-medium py-3 px-6 rounded-md text-center transition duration-300" data-id="element-168">
              Experiences of Participants
            </a>
          </div>
        </div>
      </div>
    </section>;
};